export const CLIENT_ID = "qakVL3Pr8fr5Kx6zy1TMlomDUUfdLFfna9TSpki5";
export const CLIENT_SECRET =
  "f47zzpacRTMutwTourZ4jzpGFeNG81oJI8zPtqkuMun7zo11G7FNfIAgho5NjLsgLvFzEAtPK5id8tCPx1rPkYeGen42zzR9q9bO6Qe96uTTqB4sioVP0y9ewVupkRkK";
